import script from "./Shiba.vue?vue&type=script&setup=true&lang=js"
export * from "./Shiba.vue?vue&type=script&setup=true&lang=js"

import "./Shiba.vue?vue&type=style&index=0&id=4ee8552e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ee8552e"]])

export default __exports__